// extracted by mini-css-extract-plugin
export default {"wrapper":"Generate_wrapper__prRLF"};